import React, { useState } from 'react';
import Style from './CanaisAtendimentoConteudoBlog.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '@/components/organisms/CustomEmblaCarouselHome24';

function CanaisAtendimentoConteudoBlog() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="c2c-conteudos">
        <ContainerHome24>
          <div className="is-mobi">
            <h2 className="c2c-conteudos-titulo">Consulte nossos conteúdos</h2>
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`c2c-conteudos-slide ${className}`}>
                    <a
                      href="blog/atendimento-por-whatsapp.html"
                      target="_blank"
                      className="c2c-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-19/capa.webp" />
                        <source type="image/png" srcSet="static/amp/blog/post-19/capa.jpg" />
                        <img
                          src="static/amp/blog/post-19/capa.jpg"
                          alt="Mão segurando um celular com a conversa no WhatsApp da Santander Financiamentos"
                        />
                      </picture>
                      <div className="c2c-conteudos-card-textos">
                        <h3 className="c2c-conteudos-slide-titulo">
                          Conheça o atendimento por WhatsApp da Santander Financiamentos
                        </h3>
                        <p className="c2c-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`c2c-conteudos-slide ${className}`}>
                    <a
                      href="blog/o-que-saber-sobre-boleto-digital.html"
                      target="_blank"
                      className="c2c-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-35/capa.webp" />
                        <source type="image/png" srcSet="static/amp/blog/post-35/capa.jpg" />
                        <img
                          src="static/amp/blog/post-35/capa.jpg"
                          alt="casal realizando o pagamento do boleto de quitação"
                        />
                      </picture>
                      <div className="c2c-conteudos-card-textos">
                        <h3 className="c2c-conteudos-slide-titulo">
                          Boleto digital: o que saber sobre essa forma de pagamento
                        </h3>
                        <p className="c2c-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>

                  <div className={`c2c-conteudos-slide ${className}`}>
                    <a
                      href="blog/como-gerar-um-boleto-bancario.html"
                      target="_blank"
                      className="c2c-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-1/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-1/capa.jpg" />
                        <img
                          src="static/amp/blog/post-1/capa.jpg"
                          alt="Pagando boleto bancário pelo celular"
                        />
                      </picture>
                      <div className="c2c-conteudos-card-textos">
                        <h3 className="c2c-conteudos-slide-titulo">
                          Como gerar um boleto bancário?
                        </h3>
                        <p className="c2c-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="is-desk">
            <h2 className="c2c-conteudos-titulo">Consulte nossos conteúdos</h2>
            <div className="cards-desk">
              <a
                href="blog/atendimento-por-whatsapp.html"
                target="_blank"
                className="c2c-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-19/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-19/capa.jpg" />
                  <img
                    src="static/amp/blog/post-19/capa.jpg"
                    alt="Mão segurando um celular com a conversa no WhatsApp da Santander Financiamentos"
                  />
                </picture>
                <div className="c2c-conteudos-card-textos">
                  <h3 className="c2c-conteudos-slide-titulo">
                    Conheça o atendimento por WhatsApp da Santander Financiamentos
                  </h3>
                  <p className="c2c-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/o-que-saber-sobre-boleto-digital.html"
                target="_blank"
                className="c2c-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-35/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-35/capa.jpg" />
                  <img
                    src="static/amp/blog/post-35/capa.jpg"
                    alt="casal realizando o pagamento do boleto de quitação"
                  />
                </picture>
                <div className="c2c-conteudos-card-textos">
                  <h3 className="c2c-conteudos-slide-titulo">
                    Boleto digital: o que saber sobre essa forma de pagamento
                  </h3>
                  <p className="c2c-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>

              <a
                href="blog/como-gerar-um-boleto-bancario.html"
                target="_blank"
                className="c2c-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-1/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-1/capa.jpg" />
                  <img
                    src="static/amp/blog/post-1/capa.jpg"
                    alt="Pagando boleto bancário pelo celular"
                  />
                </picture>
                <div className="c2c-conteudos-card-textos">
                  <h3 className="c2c-conteudos-slide-titulo">Como gerar um boleto bancário?</h3>
                  <p className="c2c-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default CanaisAtendimentoConteudoBlog;
